import { GET_CSR, SET_LOADING_CSR, SET_PAGINATION_CSR } from '../constant';

const initialState = {
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const csrReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_CSR: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_CSR: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_CSR: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default csrReducer;
